import { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_rainforest-portal/artifacts/jepkgtmp_AMAZONIA%20-%20Favicon%402x.png";
const WA_NUMBER = '32489102365';

export default function WhatsAppWidget() {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');

  const sendMessage = () => {
    const text = msg.trim() || 'Bonjour, je souhaite des informations sur vos produits.';
    window.open(`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`, '_blank');
    setMsg('');
    setOpen(false);
  };

  return (
    <>
      {/* Chat window */}
      {open && (
        <div data-testid="whatsapp-chat" className="fixed bottom-24 right-4 w-[340px] bg-white border border-black/10 shadow-2xl z-[55] overflow-hidden" style={{ borderRadius: '12px' }}>
          <div className="bg-[#25D366] p-4 flex items-center gap-3">
            <img src={LOGO_URL} alt="Amazonia" className="w-10 h-10 rounded-full bg-white p-1" />
            <div className="flex-1">
              <p className="text-sm font-bold text-white">AMAZONIA.FOOD</p>
              <p className="text-xs text-white/80">En ligne</p>
            </div>
            <button onClick={() => setOpen(false)} className="text-white/80 hover:text-white"><X size={18} /></button>
          </div>
          <div className="p-4 bg-[#ECE5DD] min-h-[120px]">
            <div className="bg-white p-3 rounded-lg shadow-sm max-w-[85%] text-sm text-[#111]">
              Bonjour ! Comment pouvons-nous vous aider ?
            </div>
          </div>
          <div className="p-3 border-t border-black/10 flex items-center gap-2">
            <input
              type="text"
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') sendMessage(); }}
              placeholder="Votre message..."
              className="flex-1 px-3 py-2 text-sm border border-black/15 rounded-full outline-none focus:ring-1 focus:ring-[#25D366]"
            />
            <button onClick={sendMessage} className="w-9 h-9 bg-[#25D366] text-white rounded-full flex items-center justify-center hover:bg-[#1ea952] transition-colors duration-200">
              <Send size={14} />
            </button>
          </div>
        </div>
      )}

      {/* Floating button */}
      <button
        onClick={() => setOpen(!open)}
        data-testid="whatsapp-button"
        className="fixed bottom-4 right-4 w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-200 z-[55] flex items-center justify-center"
      >
        {open ? <X size={24} /> : <MessageCircle size={24} />}
      </button>
    </>
  );
}
